export const BRAND_OPTIONS = ['D2H', 'DISH'] as const;

export const AVAILABLE_LANGUAGES = [
    'English',
    'Hindi',
    'Assamese',
    'Bangla',
    'Gujarathi',
    'Kannada',
    'Malyalam',
    'Marathi',
    'Oriya',
    'Punjabi',
    'Tamil',
    'Telugu',
];

export const MAX_LANGUAGES = 12;

export const MAX_VARIANTS_PER_LANGUAGE = 5;

export const DEFAULT_BOX_NAMES = ['HD', 'SD'];
